






























































import { defineComponent, reactive, toRefs, PropType } from "@vue/composition-api"

interface BtnInfo {
  btnText: string
  callback: () => void
}

interface cgiRes {
  ret?: number | string
  msg?: string
}

type VoidFun = () => void

// 调用示例
// root.$PromptWithIcon({
//   title: "道具评分",
//   iconStatus: false,
//   mainMsg: "很抱歉，要先购买该商品才可以评分哦~",
//   subMsg: "现在评分还可以去礼包中心领取专属评分好礼，赶紧行动吧！",
//   confirmBtnInfo: {
//     btnText: "前往礼包中心",
//     callback: () => {
//       alert("a")
//     }
//   },
//   cancelBtnInfo: {
//     btnText: "返回商品页",
//     callback: () => {
//       alert("a")
//     }
//   }
// })

export default defineComponent({
  props: {
    title: {
      type: String,
      default: "温馨提示"
    },

    // icon未空表示不展示图标，true 代表展示成功的图标， false 代表展示失败的图标
    iconStatus: {
      type: Boolean || String,
      default: ""
    },

    mainMsg: {
      type: String,
      required: true
    },

    subMsg: {
      type: String,
      required: false
    },

    hasScoreRecomm: {
      type: Boolean,
      required: false
    },

    handleScoreRecomm: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(status: boolean) => Promise<any>>,
      default: () => {
        return Promise.resolve({})
      }
    },

    cancelScoreRecomm: {
      // eslint-disable-next-line no-unused-vars
      type: Function as PropType<(status: boolean) => void>,
      default: (): void => {}
    },

    confirmBtnInfo: {
      type: Object as PropType<BtnInfo>
    },

    cancelBtnInfo: {
      type: Object as PropType<BtnInfo>
    },

    recommTags: {
      type: Array,
      required: false
    },

    selectedTags: {
      type: Array,
      required: false
    },

    selectTag: {
      type: Function as PropType<() => VoidFun>,
      default: (): void => {}
    }
  },

  setup(props) {
    const state = reactive({
      display: false,
      toastMsg: "",
      friendRecommStatus: true
    })

    const hide = (): void => {
      state.display = false
    }

    const show = (): void => {
      state.display = true
    }

    const cancel = (): void => {
      if (props.cancelBtnInfo?.callback) {
        props.cancelBtnInfo.callback()
      }
      hide()
    }

    const confirm = (): void => {
      if (props.confirmBtnInfo?.callback) {
        props.confirmBtnInfo.callback()
      }
      hide()
    }

    const cancelRecomm = event => {
      state.friendRecommStatus = event.target.checked
      props.cancelScoreRecomm && props.cancelScoreRecomm(state.friendRecommStatus)
    }

    const confirmRecomm = async () => {
      let res: cgiRes = {}
      if (props.handleScoreRecomm) {
        res = await props.handleScoreRecomm(state.friendRecommStatus)
      }
      if (res?.ret == 0) {
        hide()
      } else {
        res?.msg ? setToastMsg(res?.msg) : setToastMsg("系统繁忙，请稍后再试")
      }
    }

    const setToastMsg = msg => {
      state.toastMsg = msg

      setTimeout(() => {
        state.toastMsg = ""
      }, 2000)
    }

    return {
      ...toRefs(state),
      hide,
      show,
      cancel,
      confirm,
      confirmRecomm,
      cancelRecomm,
      setToastMsg
    }
  }
})
